import React, { useCallback, useState } from 'react'

import { BrokerSignSMSCodeForm } from '../../shared/broker/sms-form'
import { BrokerSignSuccess } from '../../shared/broker/success'
import { BrokerSignScreenBaseProps } from '../../shared/broker/types'

import { BrokerSignDocumentsList } from './docs-list'

export const BrokerAnyDocsScreen = (props: BrokerSignScreenBaseProps) => {
	const [step, setStep] = useState(0)
	const handleNext = useCallback(() => setStep((step) => step + 1), [])

	if (step === 0) {
		return React.createElement(BrokerSignDocumentsList, {
			...props,
			onNext: handleNext,
		})
	}

	if (step === 1) {
		return React.createElement(BrokerSignSMSCodeForm, {
			...props,
			onNext: handleNext,
			title: 'Подтвердите подписание',
		})
	}

	return React.createElement(BrokerSignSuccess, {
		content: 'Документы успешно подписаны.',
	})
}
